import { useContext, useEffect, useState } from "react";
import { GridFill, List } from "react-bootstrap-icons";
//import "./ProductosView.scss";
import "./CatalogView.scss"
import { fetchProductListData } from "../services/ProductServices";
import { Link, useLocation, useParams } from "react-router-dom";
import ProductosComponent from "../components/productos/ProductsComponent";
import { Alert, FormSelect, Spinner } from "react-bootstrap";
import CustomPagination from "../components/Pagination";
import { AuthContext } from "../services/AuthContext";
import { PageContext } from "../services/PageContext";
import ReactRecaptcha3 from 'react-google-recaptcha3';

export default function SearchView({save = true}) {
  const { searchTerm } = useParams();
  const [viewType, setViewType] = useState("grid");
  const [productos, setProductos] = useState([]);
  const [cantProd, setCantProd] = useState(0);
  const [loading, setLoading] = useState(false);
  const [suggest, setSuggest] = useState('');

  const location = useLocation();
  const current = location.pathname;
  const [variant, setVariant] = useState('danger')
  const [visibleError, setVisibleError] = useState(false)
  const [message, setMessage] = useState('')
  
  const { isAuthenticated, user } = useContext(AuthContext);
  const { currentPage, totalPages, itemsPerPage, paginate, handleLimitChange, setTotalPages, pageGroup } = useContext(PageContext);

  useEffect(()=>{
    let ignore = false;
    let params = {
      page: currentPage,
      itemsPerPage: itemsPerPage,
      estado : 1,
      search: searchTerm,
      save: save
    };
    if (user) {
      params = {
        ...params,
        user: user.id,
        isSeller: user.isSeller,
      }
      if (user.isSeller && (user.clientSelected && user.clientSelected !== 0)) {
        params = {
          ...params,
          clientId: user.clientSelected
        }
      }
    }
    if (current.split('/')[1] === 'buscaDesdeAdmin') {
      if (ignore) return;
      setLoading(true);
      fetchProductListData(params)
        .then(data => {
          setProductos(data.productos);
          setCantProd(data.productos.length);
          setTotalPages(data.totalPages);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(()=>{setLoading(false)})
    } else {
      if (current.split('/')[1] === 'buscar') {
        ReactRecaptcha3.getToken().then(
          (resp) => {
            if (ignore) return;
            setLoading(true);
              fetchProductListData(params)
                .then(data => {
                  setProductos(data.productos);
                  setCantProd(data.productos.length);
                  setTotalPages(data.totalPages);
                  setSuggest(data.sugerencia)
                })
                .catch(err => {
                  console.log(err);
                })
                .finally(()=>{setLoading(false)})
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        const type = current.split('/')[1] === 'productos-nuevos' ? 'new' : 'updates';
        params = {
          ...params,
          type: type,
        }
        if (ignore) return;
        setLoading(true);
        fetchProductListData(params)
          .then(data => {
            setProductos(data.productos);
            setCantProd(data.productos.length);
            setTotalPages(data.totalPages);
          })
          .catch(err => {
            console.log(err);
          })
          .finally(()=>{setLoading(false)})
      }
    }
    return () => { ignore = true };
  },[searchTerm, currentPage, itemsPerPage, current]);

  useEffect(() => {
    const el = document.getElementById(sessionStorage.getItem('idProductos'));
    if (el) {
      el.scrollIntoView({ behavior: "smooth" }); // animación suave
    } else {
      window.scrollTo(0,0)
    }
  }, [productos]);

  return (
    <>
      {loading ?
        <div className="content-loading">
          <Spinner variant="success" />
        </div>
        :
        <>
          <Alert variant={variant} dismissible show={visibleError} onClose={() => setVisibleError(false)}>
            {message}
          </Alert>
          <div className="search-view catalog-content">
            <div className="catalog-list">
              <div className="category-list-header">
                <div>
                  <div className="category-list-header-title">
                    <h4>Resultado de la búsqueda</h4>
                    <div className="subtitle">
                      ({cantProd} productos encontrados.)
                    </div>
                  </div>
                  {suggest && suggest !== '' ? <span> Quiso decir <Link to={`/buscar/${suggest}`}>{suggest}</Link>?</span>:null}
                </div>
                <div className="category-list-header-data">
                  <div>
                    <label>Cant. por Pag.</label>
                    <FormSelect id="limit" value={itemsPerPage} onChange={handleLimitChange}>
                      {pageGroup.map((item)=> {
                        return <option value={item} key={`limit_${item}`}>{item}</option>
                      })}
                    </FormSelect>
                  </div>
                  <div className="view-type-content">
                    <div
                      className={viewType === "grid" ? "icon  active" : "icon"}
                      onClick={() => setViewType("grid")}
                    >
                      <GridFill />
                    </div>
                    <div
                      className={viewType === "list" ? "icon  active" : "icon"}
                      onClick={() => setViewType("list")}
                    >
                      <List />
                    </div>
                  </div>
                </div>
              </div>
              <ProductosComponent viewType={viewType} products={productos} authenticated={isAuthenticated} onVisible={setVisibleError} onMessage={setMessage}/>
              <CustomPagination currentPage={currentPage} goToPage={paginate} totalPages={totalPages} />
            </div>
          </div>
        </>
      }
    </>
  );
}
